<template>
    <div class="block blok-1 p-0">
        <b-row no-gutters class="strip-name-1 ml-0">
            <b-col cols="12" class="p-0">
                <b-row no-gutters class="strip-name-1 ml-0 pt-0">
                    <b-col cols="6" md="5" offset-md="1" class="head-block">
                        <div class="caption-bigger">
                            {{ this.generateVaultName(vault) }}
                        </div>
                        <div class="caption">
                            PHYSICAL-{{ vault.type.replace("_", "-") }}
                        </div>
                        <div class="caption">
                            {{ vault.time_period }}
                        </div>
                    </b-col>
                    <b-col
                        cols="6"
                        md="6"
                        class="head-block pl-0 icon-coin-container right-text-mobile"
                    >
                        <img :src="itemIcon" alt="coin vault strip" />
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="8" md="11" offset-md="1" class="pr-0 pl-1">
                <div class="percentage" id="apy-percentage">
                    {{
                        vault.apy < 0
                            ? `${moneyFormat(vault.apy)}`
                            : `+${moneyFormat(vault.apy)}`
                    }}%
                </div>
                <div class="percentage-description">
                    Current Projected Yield (APY)
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState("il", ["vault"]),
        itemIcon() {
            return `/images/crypto-icons/icon-coin-${this.vault.token}.svg`;
        }
    }
};
</script>
